var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loaded)?_c('Dashboard',{attrs:{"stats":_vm.stats},on:{"downloadFile":_vm.downloadFile}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }